/**
 * @generated SignedSource<<d2eff4bb1d1c35fe29877cb2a058b51b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFacetBlock_facets$data = ReadonlyArray<{
  readonly count: number | null;
  readonly label: string | null;
  readonly name: string | null;
  readonly " $fragmentType": "PhotosSearchBrowseFacetBlock_facets";
}>;
export type PhotosSearchBrowseFacetBlock_facets$key = ReadonlyArray<{
  readonly " $data"?: PhotosSearchBrowseFacetBlock_facets$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetBlock_facets">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PhotosSearchBrowseFacetBlock_facets",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "FacetValueType",
  "abstractKey": null
};

(node as any).hash = "623678dae2851737349e5ac93cb9db25";

export default node;
